// @flow
import { SHAPES } from '../../server/shared/constants/zoneConstants';
import type { Action, Vehicle } from '../types';
import * as constants from '../constants/vehicleConstants';

export type State = $ReadOnly<{
    list: $ReadOnlyArray<$PropertyType<Vehicle, 'id'>>,
    entities: $ReadOnly<{
        [id: string]: Vehicle
    }>,
    status: $ReadOnly<{
        isLoading: boolean,
        error: boolean
    }>
}>;

const initialState = {
    list: [],
    entities: {},
    status: {
        isLoading: false,
        error: false
    }
};

export default function vehicles(state: State = initialState, action: Action): State {
    switch(action.type) {
        case constants.LOAD: {
            const list = [];
            const entities = {};

            for(let i = 0, length = action.data.length; i < length; i += 1) {
                const vehicle = action.data[i];
                const icao = vehicle.icao;

                list.push(icao);
                entities[icao] = vehicle;
            }

            return {
                ...state,
                list,
                entities
            };
        }

        case constants.SET: {
            const icao = action.data.icao;

            let list = state.list;
            if(list.indexOf(icao) === -1) {
                list = [
                    ...list,
                    icao
                ];
            }

            return {
                ...state,
                list,
                entities: {
                    ...state.entities,
                    [icao]: action.data
                }
            };
        }

        case constants.UNSET: {
            const icao = action.data.icao;
            let list = state.list;

            let isChanged = false;
            const index = list.indexOf(icao);
            if(index !== -1) {
                isChanged = true;
                list = [].concat(list);
                list.splice(index, 1);
            }

            let entities = state.entities;
            if(state.entities[icao]) {
                isChanged = true;
                entities = {
                    ...state.entities
                };
                delete entities[icao];
            }

            if(!isChanged) {
                return state;
            }

            return {
                ...state,
                list,
                entities
            };
        }

        default:
            return state;
    }
}